// rdata.js

const resourceLinks = {
    "13": {
      name: "Computer Science and Engineering",
      resources: {
        "Semester (1)": "https://drive.google.com/cse-sem1",
        "Semester (2)": "https://drive.google.com/cse-sem2",
        "Semester (3)": "https://drive.google.com/ee-sem2",
        "Semester (4)": "https://drive.google.com/ee-sem2",
        "Semester (5)": "https://drive.google.com/ee-sem2",
        "Semester (6)": "https://drive.google.com/ee-sem2",
        "Semester (7)": "https://drive.google.com/ee-sem2",
        "Semester (8)": "https://drive.google.com/ee-sem2",
      },
    },
    "8": {
      name: "Electronics and Communication",
      resources: {
        "Semester (1)": "https://drive.google.com/cse-sem1",
        "Semester (2)": "https://drive.google.com/cse-sem2",
        "Semester (3)": "https://drive.google.com/ee-sem2",
        "Semester (4)": "https://drive.google.com/ee-sem2",
        "Semester (5)": "https://drive.google.com/ee-sem2",
        "Semester (6)": "https://drive.google.com/ee-sem2",
        "Semester (7)": "https://drive.google.com/ee-sem2",
        "Semester (8)": "https://drive.google.com/ee-sem2",
      },
    },
    "9": {
      name: "Electrical Engineering",
      resources: {
        "Semester (1)": "https://drive.google.com/cse-sem1",
        "Semester (2)": "https://drive.google.com/cse-sem2",
        "Semester (3)": "https://drive.google.com/ee-sem2",
        "Semester (4)": "https://drive.google.com/ee-sem2",
        "Semester (5)": "https://drive.google.com/ee-sem2",
        "Semester (6)": "https://drive.google.com/ee-sem2",
        "Semester (7)": "https://drive.google.com/ee-sem2",
        "Semester (8)": "https://drive.google.com/ee-sem2",
      },
    },
    "7": {
      name: "Civil Engineering",
      resources: {
        "Semester (1)": "https://drive.google.com/cse-sem1",
        "Semester (2)": "https://drive.google.com/cse-sem2",
        "Semester (3)": "https://drive.google.com/ee-sem2",
        "Semester (4)": "https://drive.google.com/drive/folders/1-vXz0kCwkMUYa4pWJ2Z6Y3DOUSVPjImY",
        "Semester (5)": "https://drive.google.com/drive/folders/1YdSkX5RZsOqmJ8Jm9mU0TOdYeJCdNcLk?usp=drive_link",
        "Semester (6)": "https://drive.google.com/ee-sem2",
        "Semester (7)": "https://drive.google.com/ee-sem2",
        "Semester (8)": "https://drive.google.com/ee-sem2",
      },
    },
  };
  
  export default resourceLinks;
  